class FontsMapper {
    constructor() {
        this.fonts = {
            // "3342" - id produktu: czcionki - ARIAL
            "3342": {
                "normal": {
                    "25": {
                        "name": "Arial Bold-25",
                        "path": "fonts/Rodlew-ARIALBOLD-CLR-25.otf"
                    },
                    "30": {
                        "name": "Arial Bold-30",
                        "path": "fonts/Rodlew-ARIALBOLD-30.otf"
                    },
                    "40": {
                        "name": "Arial Bold-40",
                        "path": "fonts/Rodlew-ARIALBOLD-40.otf"
                    },
                    "50": {
                        "name": "Arial Bold-50",
                        "path": "fonts/Rodlew-ARIALBOLD-50.otf"
                    },
                    "60": {
                        "name": "Arial Bold-60",
                        "path": "fonts/Rodlew-ARIALBOLD-60.otf"
                    }
                },
                "clr": {
                    "25": {
                        "name": "Arial Bold CLR-25",
                        "path": "fonts/Rodlew-ARIALBOLD-CLR-25.ttf"
                    },
                    "30": {
                        "name": "Arial Bold CLR-30",
                        "path": "fonts/Rodlew-ARIALBOLD-CLR-30.ttf"
                    },
                    "40": {
                        "name": "Arial Bold CLR-40",
                        "path": "fonts/Rodlew-ARIALBOLD-CLR-40.ttf"
                    },
                    "50": {
                        "name": "Arial Bold CLR-50",
                        "path": "fonts/Rodlew-ARIALBOLD-CLR-50.ttf"
                    },
                    "60": {
                        "name": "Arial Bold CLR-60",
                        "path": "fonts/Rodlew-ARIALBOLD-CLR-60.ttf"
                    }
                }
            },
            // "3336" - id Atrybut produktu: czcionki - Romano
            "3336": {
                "normal": {
                    "20": {
                        "name": "Romano-20",
                        "path": "fonts/Rodlew-ROMANO-20.otf"
                    },
                    "25": {
                        "name": "Romano-25",
                        "path": "fonts/Rodlew-ROMANO-25.otf"
                    },
                    "30": {
                        "name": "Romano-30",
                        "path": "fonts/Rodlew-ROMANO-30.otf"
                    },
                    "35": {
                        "name": "Romano-35",
                        "path": "fonts/Rodlew-ROMANO-35.otf"
                    },
                    "40": {
                        "name": "Romano-40",
                        "path": "fonts/Rodlew-ROMANO-40.otf"
                    },
                    "50": {
                        "name": "Romano-50",
                        "path": "fonts/Rodlew-ROMANO-50.otf"
                    },
                    "60": {
                        "name": "Romano-60",
                        "path": "fonts/Rodlew-ROMANO-60.otf"
                    }
                },
                "clr": {
                    "20": {
                        "name": "Romano CLR-20",
                        "path": "fonts/Rodlew-ROMANO-CLR-20.ttf"
                    },
                    "25": {
                        "name": "Romano CLR-25",
                        "path": "fonts/Rodlew-ROMANO-CLR-25.ttf"
                    },
                    "30": {
                        "name": "Romano CLR-30",
                        "path": "fonts/Rodlew-ROMANO-CLR-30.ttf"
                    },
                    "35": {
                        "name": "Romano CLR-35",
                        "path": "fonts/Rodlew-ROMANO-CLR-35.ttf"
                    },
                    "40": {
                        "name": "Romano CLR-40",
                        "path": "fonts/Rodlew-ROMANO-CLR-40.ttf"
                    },
                    "50": {
                        "name": "Romano CLR-50",
                        "path": "fonts/Rodlew-ROMANO-CLR-50.ttf"
                    },
                    "60": {
                        "name": "Romano CLR-60",
                        "path": "fonts/Rodlew-ROMANO-CLR-60.ttf"
                    }
                }
            },
            // "3334" - id Atrybut produktu: czcionki - Rodlew
            "3334": {
                "normal": {
                    "20": {
                        "name": "Rodlew-20",
                        "path": "fonts/Rodlew-RODLEW-20.otf"
                    },
                    "25": {
                        "name": "Rodlew-25",
                        "path": "fonts/Rodlew-RODLEW-25.otf"
                    },
                    "30": {
                        "name": "Rodlew-30",
                        "path": "fonts/Rodlew-RODLEW-30.otf"
                    },
                    "40": {
                        "name": "Rodlew-40",
                        "path": "fonts/Rodlew-RODLEW-40.otf"
                    },
                    "50": {
                        "name": "Rodlew-50",
                        "path": "fonts/Rodlew-RODLEW-50.otf"
                    },
                    "60": {
                        "name": "Rodlew-60",
                        "path": "fonts/Rodlew-RODLEW-60.otf"
                    }
                },
                "clr": {
                    "20": {
                        "name": "Rodlew CLR-20",
                        "path": "fonts/Rodlew-RODLEW-CLR-20.ttf"
                    },
                    "25": {
                        "name": "Rodlew CLR-25",
                        "path": "fonts/Rodlew-RODLEW-CLR-25.ttf"
                    },
                    "30": {
                        "name": "Rodlew CLR-30",
                        "path": "fonts/Rodlew-RODLEW-CLR-30.ttf"
                    },
                    "40": {
                        "name": "Rodlew CLR-40",
                        "path": "fonts/Rodlew-RODLEW-CLR-40.ttf"
                    },
                    "50": {
                        "name": "Rodlew CLR-50",
                        "path": "fonts/Rodlew-RODLEW-CLR-50.ttf"
                    },
                    "60": {
                        "name": "Rodlew CLR-60",
                        "path": "fonts/Rodlew-RODLEW-CLR-60.ttf"
                    }
                }
            },
            // "3332" - id Atrybut produktu: czcionki - Kursywa odzielna
            "3332": {
                "normal": {
                    "20": {
                        "name": "Corsiva-20",
                        "path": "fonts/Rodlew-CORSIVA-20.otf"
                    },
                    "25": {
                        "name": "Corsiva-25",
                        "path": "fonts/Rodlew-CORSIVA-25.otf"
                    },
                    "30": {
                        "name": "Corsiva-30",
                        "path": "fonts/Rodlew-CORSIVA-30.otf"
                    },
                    "35": {
                        "name": "Corsiva-35",
                        "path": "fonts/Rodlew-CORSIVA-35.otf"
                    },
                    "40": {
                        "name": "Corsiva-40",
                        "path": "fonts/Rodlew-CORSIVA-40.otf"
                    },
                    "50": {
                        "name": "Corsiva-50",
                        "path": "fonts/Rodlew-CORSIVA-50.otf"
                    },
                    "60": {
                        "name": "Corsiva-60",
                        "path": "fonts/Rodlew-CORSIVA-60.otf"
                    }
                },
                "clr": {
                    "20": {
                        "name": "Corsiva CLR-20",
                        "path": "fonts/Rodlew-CORSIVA-CLR-20.ttf"
                    },
                    "25": {
                        "name": "Corsiva CLR-25",
                        "path": "fonts/Rodlew-CORSIVA-CLR-25.ttf"
                    },
                    "30": {
                        "name": "Corsiva CLR-30",
                        "path": "fonts/Rodlew-CORSIVA-CLR-30.ttf"
                    },
                    "35": {
                        "name": "Corsiva CLR-35",
                        "path": "fonts/Rodlew-CORSIVA-CLR-35.ttf"
                    },
                    "40": {
                        "name": "Corsiva CLR-40",
                        "path": "fonts/Rodlew-CORSIVA-CLR-40.ttf"
                    },
                    "50": {
                        "name": "Corsiva CLR-50",
                        "path": "fonts/Rodlew-CORSIVA-CLR-50.ttf"
                    },
                    "60": {
                        "name": "Corsiva CLR-60",
                        "path": "fonts/Rodlew-CORSIVA-CLR-60.ttf"
                    }
                }
            },
            // "53658" - id Atrybut produktu: czcionki - Kursywa łączona
            "53658": {
                "normal": {
                    "20": {
                        "name": "Kursywa-20",
                        "path": "fonts/Rodlew-KURSYWA-20.otf"
                    },
                    "30": {
                        "name": "Kursywa-30",
                        "path": "fonts/Rodlew-KURSYWA-30.otf"
                    },
                    "35": {
                        "name": "Kursywa-35",
                        "path": "fonts/Rodlew-KURSYWA-35.otf"
                    }
                },
                "clr": {
                    "20": {
                        "name": "Kursywa-20",
                        "path": "fonts/Rodlew-KURSYWA-CLR-20.otf"
                    },
                    "30": {
                        "name": "Kursywa-30",
                        "path": "fonts/Rodlew-KURSYWA-CLR-30.otf"
                    },
                    "35": {
                        "name": "Kursywa-35",
                        "path": "fonts/Rodlew-KURSYWA-CLR-30.otf"
                    }
                }
            },
            // "3338" - id Atrybut produktu: czcionki - Szerokie
            "3338": {
                "normal": {
                    "20": {
                        "name": "Szerokie-20",
                        "path": "fonts/Rodlew-SZEROKIE-20.otf"
                    },
                    "25": {
                        "name": "Szerokie-25",
                        "path": "fonts/Rodlew-SZEROKIE-25.otf"
                    },
                    "35": {
                        "name": "Szerokie-35",
                        "path": "fonts/Rodlew-SZEROKIE-35.otf"
                    },
                    "40": {
                        "name": "Szerokie-40",
                        "path": "fonts/Rodlew-SZEROKIE-40.otf"
                    },
                    "50": {
                        "name": "Szerokie-50",
                        "path": "fonts/Rodlew-SZEROKIE-50.otf"
                    },
                    "60": {
                        "name": "Szerokie-60",
                        "path": "fonts/Rodlew-SZEROKIE-60.otf"
                    }
                },
                "clr": {
                    "20": {
                        "name": "Szerokie CLR-20",
                        "path": "fonts/Rodlew-SZEROKIE-CLR-20.ttf"
                    },
                    "25": {
                        "name": "Szerokie CLR-25",
                        "path": "fonts/Rodlew-SZEROKIE-CLR-25.ttf"
                    },
                    "35": {
                        "name": "Szerokie CLR-35",
                        "path": "fonts/Rodlew-SZEROKIE-CLR-35.ttf"
                    },
                    "40": {
                        "name": "Szerokie CLR-40",
                        "path": "fonts/Rodlew-SZEROKIE-CLR-40.ttf"
                    },
                    "50": {
                        "name": "Szerokie CLR-50",
                        "path": "fonts/Rodlew-SZEROKIE-CLR-50.ttf"
                    },
                    "60": {
                        "name": "Szerokie CLR-60",
                        "path": "fonts/Rodlew-SZEROKIE-CLR-60.ttf"
                    }
                }
            },
            // "3340" - id Atrybut produktu: czcionki - Waskie
            "3340": {
                "normal": {
                    "20": {
                        "name": "Waskie-20",
                        "path": "fonts/Rodlew-WASKIE-20.otf"
                    },
                    "25": {
                        "name": "Waskie-25",
                        "path": "fonts/Rodlew-WASKIE-25.otf"
                    },
                    "30": {
                        "name": "Waskie-30",
                        "path": "fonts/Rodlew-WASKIE-30.otf"
                    },
                    "40": {
                        "name": "Waskie-40",
                        "path": "fonts/Rodlew-WASKIE-40.otf"
                    },
                    "50": {
                        "name": "Waskie-50",
                        "path": "fonts/Rodlew-WASKIE-50.otf"
                    },
                    "60": {
                        "name": "Waskie-60",
                        "path": "fonts/Rodlew-WASKIE-60.otf"
                    }
                },
                "clr": {
                    "20": {
                        "name": "Waskie CLR-20",
                        "path": "fonts/Rodlew-WASKIE-CLR-20.ttf"
                    },
                    "25": {
                        "name": "Waskie CLR-25",
                        "path": "fonts/Rodlew-WASKIE-CLR-25.ttf"
                    },
                    "30": {
                        "name": "Waskie CLR-30",
                        "path": "fonts/Rodlew-WASKIE-CLR-30.ttf"
                    },
                    "40": {
                        "name": "Waskie CLR-40",
                        "path": "fonts/Rodlew-WASKIE-CLR-40.ttf"
                    },
                    "50": {
                        "name": "Waskie CLR-50",
                        "path": "fonts/Rodlew-WASKIE-CLR-50.ttf"
                    },
                    "60": {
                        "name": "Waskie CLR-60",
                        "path": "fonts/Rodlew-WASKIE-CLR-60.ttf"
                    }
                }
            }
        }
    }
}
export default FontsMapper;
